import { ADMIN_STATE_KEY } from "~/admin";
import { ADDRESS_STATE_DATA_KEY } from "./reducer";

const _getModuleState = (state) => state[ADMIN_STATE_KEY][ADDRESS_STATE_DATA_KEY];

export const getCountryStateList = (state) => _getModuleState(state).countryStateList;
